(() => {
  const KEY = 'bcos:recently-viewed';
  const CONTEXT_KEY = 'bcos:last-context';
  const MAX_STORED = 24;

  const sections = [...document.querySelectorAll('[data-bcos-recently-viewed]')];

  const root = window.Shopify?.routes?.root || '/';

  function formatMoney(cents) {
    return window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents, window.Shopify?.moneyFormat)
      : `$${(cents / 100).toFixed(2)}`;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (ch) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    })[ch]);
  }

  function readList() {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function recordCurrent() {
    const script = document.querySelector('[data-bcos-recently-viewed-current]');
    if (!script) return;
    try {
      const product = JSON.parse(script.textContent);
      if (!product || !String(product.id) || !product.title) return;
      const list = readList();
      const filtered = list.filter((item) => String(item.id) !== String(product.id));
      filtered.unshift({ ...product, viewedAt: Date.now() });
      writeList(filtered.slice(0, MAX_STORED));
    } catch (error) {
      /* ignore malformed embedded data */
    }
  }

  function cardHtml(item) {
    const price = parseInt(item.price || '0', 10);
    const compareAt = parseInt(item.compareAt || '0', 10);
    const link = item.url || `${root}products/${encodeURIComponent(item.handle || '')}`;
    const variantId = item.variantId || item.id;
    const image = item.image || '';
    return `
      <article class="bcos-card" data-product-card>
        <div class="bcos-card__media">
          <a href="${escapeHtml(link)}" class="bcos-card__link">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.title)}" width="240" height="300" loading="lazy">` : `<span class="bcos-card__placeholder" aria-hidden="true"><svg class="bcos-card__placeholder-svg" viewBox="0 0 24 24" fill="none" focusable="false"><rect x="2.5" y="3.5" width="19" height="17" rx="1.5" stroke="currentColor" stroke-width="1.5"/><circle cx="9" cy="9" r="1.75" fill="currentColor"/><path d="M4 18l5-5 3 3 4-4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`}
          </a>
          <ul class="bcos-card__badges" role="list">
            ${item.available === false ? `<li class="bcos-badge bcos-badge--sold-out">Sold out</li>` : (compareAt > price ? `<li class="bcos-badge bcos-badge--sale">Sale</li>` : '')}
          </ul>
          <div class="bcos-card__actions" role="group" aria-label="Quick actions">
            <button
              class="bcos-card__action"
              type="button"
              data-bcos-quick-add
              data-variant-id="${variantId}"
              data-variant-available="${item.available !== false}"
              data-product-url="${escapeHtml(link)}"
              aria-label="Add to cart"
              ${item.available === false ? 'disabled' : ''}
            >
              <svg class="bcos-icon bcos-icon--bag" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" d="M5 8h14l-1 13H6L5 8zm3 0a4 4 0 0 1 8 0"/></svg>
            </button>
            <button
              class="bcos-card__action"
              type="button"
              data-bcos-quick-view
              data-product-url="${escapeHtml(link)}"
              data-product-handle="${escapeHtml(item.handle || '')}"
              aria-label="Quick view"
            >
              <svg class="bcos-icon bcos-icon--eye" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"/><circle fill="none" stroke="currentColor" stroke-width="1.8" cx="12" cy="12" r="2.6"/></svg>
            </button>
            <button
              class="bcos-card__action"
              type="button"
              data-bcos-wishlist
              data-product-id="${item.id}"
              data-product-variant-id="${variantId}"
              data-product-handle="${escapeHtml(item.handle || '')}"
              data-product-title="${escapeHtml(item.title)}"
              data-product-price="${item.price || '0'}"
              data-product-compare-at-price="${item.compareAt || '0'}"
              data-product-image="${escapeHtml(image)}"
              data-product-url="${escapeHtml(link)}"
              aria-pressed="false"
              aria-label="Add to wishlist"
            >
              <svg class="bcos-icon bcos-icon--heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M12 20s-7-4.5-9-9a5 5 0 0 1 9-3.5A5 5 0 0 1 21 11c-2 4.5-9 9-9 9z"/></svg>
            </button>
            <button
              class="bcos-card__action"
              type="button"
              data-bcos-compare
              data-product-id="${item.id}"
              data-product-variant-id="${variantId}"
              data-product-handle="${escapeHtml(item.handle || '')}"
              data-product-title="${escapeHtml(item.title)}"
              data-product-price="${item.price || '0'}"
              data-product-compare-at-price="${item.compareAt || '0'}"
              data-product-image="${escapeHtml(image)}"
              data-product-url="${escapeHtml(link)}"
              aria-pressed="false"
              aria-label="Add to compare"
            >
              <svg class="bcos-icon bcos-icon--compare" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M7 3v18M4 6l3-3 3 3M17 3v18m-3-3 3 3 3-3"/></svg>
            </button>
          </div>
        </div>
        <div class="bcos-card__body">
          <h3 class="bcos-card__title">
            <a href="${escapeHtml(link)}">${escapeHtml(item.title)}</a>
          </h3>
          <p class="bcos-price">
            <span class="bcos-price__amount">${formatMoney(price)}</span>
            ${compareAt > price ? `<s class="bcos-price__compare">${formatMoney(compareAt)}</s>` : ''}
          </p>
        </div>
      </article>`;
  }

  function renderSection(section) {
    const limit = parseInt(section.dataset.limit || '4', 10);
    const grid = section.querySelector('[data-bcos-recently-viewed-grid]');
    const empty = section.querySelector('[data-bcos-recently-viewed-empty]');
    const clear = section.querySelector('[data-bcos-recently-viewed-clear]');
    if (!grid) return;

    const list = readList().slice(0, limit);
    if (!list.length) {
      grid.classList.add('is-empty');
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (clear) clear.hidden = true;
      return;
    }
    grid.classList.remove('is-empty');
    grid.innerHTML = list.map(cardHtml).join('');
    if (empty) empty.hidden = true;
    if (clear) clear.hidden = false;
  }

  function renderAll() {
    sections.forEach(renderSection);
  }

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-bcos-recently-viewed-clear]');
    if (!clear) return;
    event.preventDefault();
    localStorage.removeItem(KEY);
    renderAll();
  });

  function rememberContext() {
    if (typeof document.body.dataset.bcosTemplate === 'string') {
      const template = document.body.dataset.bcosTemplate;
      if (template === 'collection' || template === 'search') {
        try {
          localStorage.setItem(CONTEXT_KEY, window.location.href);
        } catch (error) {
          /* storage unavailable */
        }
      }
    }
  }

  function wireContinueShopping() {
    if (!sections.length) {
      const links = document.querySelectorAll('[data-bcos-continue-shopping]');
      if (!links.length) return;
    }
    let url = null;
    try {
      url = localStorage.getItem(CONTEXT_KEY);
    } catch (error) {
      return;
    }
    if (!url) return;
    document.querySelectorAll('[data-bcos-continue-shopping]').forEach((link) => {
      link.setAttribute('href', url);
    });
  }

  rememberContext();
  wireContinueShopping();
  recordCurrent();
  renderAll();
})();
